import * as d3 from 'd3';
import {WebMercatorViewport} from '@deck.gl/core';
import {COORDINATE_SYSTEM} from '@deck.gl/core';

export const COORDINATE_ORIGIN = [19, 47];

export function fitBounds(width, height, nw, se) {
  const viewport = new WebMercatorViewport({width, height});
  const {latitude, longitude, zoom} = viewport.fitBounds([nw, se]);
  return {latitude, longitude, zoom};
}

export const CENTER_COORDS = {
  latitude:  47.180086,
  longitude: 19.503736
}

export const INITIAL_VIEW_STATE = {
  ...CENTER_COORDS,
  zoom: 6.7,
  bearing: 0,
  pitch: 0,
  nw: [16.0022982113, 45.5594811061],
  se: [24.510531447, 48.8238540716]
}

export const COLOR_RANGE = [
  [150, 200, 235],
  [73, 227, 206],
  [216, 254, 181],
  [254, 237, 177],
  [254, 173, 84],
  [209, 55, 78]
];

export const GEO_JSON = {
  data: 'megye.json',
  visible: true,
  getLineWidth: 1,
  getLineColor: [160, 160, 160, 0],
  getFillColor: [255, 255, 255, 0],
  lineWidthUnits: 'pixels',
  transitions: {
    getLineColor:1500
  },
};

export const SCATTERPLOT = {
  id: 'scatterplot-layer',
  coordinateSystem: COORDINATE_SYSTEM.LNGLAT_OFFSETS,
  coordinateOrigin: COORDINATE_ORIGIN,
  visible: true,
  pickable: true,
  opacity: 0.8,
  stroked: false,
  filled: true,
  radiusScale: 6,
  radiusMinPixels: 1,
  radiusMaxPixels: 10,
  lineWidthMinPixels: 1,
  getPosition: d => d.geometry.coordinates,
  getRadius: 10,
  getFillColor: d => [255, 0, 0, 0],
  transitions: {
    getFillColor: {
      duration: 1500,
      easing: d3.easeSinInOut
    },
    getPosition: 1500
  }
};


